import { render, staticRenderFns } from "./FormRowHeader.vue?vue&type=template&id=26996cf6&scoped=true&"
import script from "./FormRowHeader.vue?vue&type=script&lang=js&"
export * from "./FormRowHeader.vue?vue&type=script&lang=js&"
import style0 from "./FormRowHeader.vue?vue&type=style&index=0&id=26996cf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26996cf6",
  null
  
)

export default component.exports